<style>
  .img-circle {
    border-radius: 50%;
  }

  .blockDisplay {
    display: block !important;
  }

  .ProfilePic {
    margin: 0 auto;
    max-width: 100px;
    max-height: 100px;
  }

  .toolbar {
    background-color: rgba(255, 255, 255, 0.00) !important;
  }

  .v-list__tile__sub-title {
    display: block !important;
  }
</style>
<template>
  <v-container grid-list-md justify-space-around="True" style="height: 100%;">
    <v-layout row wrap>
      <!--Budget Settings-->
      <v-flex xs12 sm12 md6>
        <v-card>
          <v-toolbar card dense>
            <v-toolbar-title>
              MWW Options
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip v-if="editOptions" bottom>
              <v-btn icon v-if="editOptions" @click.native="editOptions = !editOptions" slot="activator">
                <v-icon small color="teal">far fa-edit</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip v-if="!editOptions" bottom>
              <v-btn icon v-if="!editOptions" @click.native="saveOptions = !saveOptions; editOptions = !editOptions" slot="activator">
                <v-icon small color="green">far fa-save</v-icon>
              </v-btn>
              <span>Save</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-list subheader
                    two-line>
              <!--<v-subheader>Budget Settings </v-subheader>-->
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="subheader">Select currency</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-flex xs12 sm12 md12 d-flex>
                        <v-autocomplete v-model="currency"
                                    :disabled="editOptions"
                                    :items="currencies"
                                    :chips="!editOptions"
                                    multiple></v-autocomplete>


                      <!--<v-list>

                      </v-list>-->

                  </v-flex>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="subheader">Tax (GCT) </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-flex xs12 sm12 md12 d-flex>
                      <v-text-field v-model="gct"
                                    :disabled="editOptions"
                                    suffix="%"></v-text-field>
                    </v-flex>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          <v-divider></v-divider>
            <v-list subheader
                    three-line>
              <!--<v-subheader>Language & Location </v-subheader>-->
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="subheader">Language preference</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-flex xs12 sm12 md12 d-flex>
                      <v-select color="primary"
                                solo
                                dense
                                :disabled="true"
                                v-model="language"
                                :items="languages"></v-select>
                    </v-flex>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="subheader">Country</v-list-tile-title>
                  <v-list-tile-sub-title>
                    <v-flex xs12 sm12 md12 d-flex>
                      <v-autocomplete color="primary"
                                solo
                                dense
                                :disabled="editOptions"
                                v-model="country"
                                :items="countries"></v-autocomplete>
                    </v-flex>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex>
        <v-card>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>
<script>
  export default {
    data() {
      return {
        saveOptions: false,
        editOptions: true,
        model: null,
        gct: '16.5',
        currency: ['USD - U.S Dollar'],
        country: 'Jamaica',
        language: 'English',
        currencies: ['USD - U.S Dollar', 'JMD - Jamaican Dollar'],
        countries: ["Anguilla", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Islands", "Australia", "Austria", "Azerbaijan", "The Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Botswana", "Brazil", "British Virgin Islands", "Canada", "Cayman Islands", "Chile", "China", "Colombia", "Costa Rica", "Cuba", "Czech Republic", "Denmark", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
          "Finland", "France", "French Guiana", "Germany", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Ireland", "Italy", "Jamaica", "Japan", "Martinique", "Mexico", "Montserrat", "Netherlands", "Netherlands Antilles", "New Zealand", "Norway", "Panama", "Poland", "Portugal", "Puerto Rico", "Qatar", "Romania", "Russia", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Saudi Arabia", "Sweden", "Switzerland", "Trinidad and Tobago", "Turkey", "Turks and Caicos Islands", "United Kingdom", "United States", "Venezuela"],
        languages: ['English', 'Spanish','French']
      }
    },
    methods: {
      updateCurrency: function () {

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/generalSettings/GeneralSettings.vue